import {
  Bell,
  CircleCheck,
  CircleX,
  KeyRound,
  Rocket,
  ServerOff,
  ShieldQuestion,
  Users,
  Workflow,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { NotificationType } from '../../api/types.ts';

const iconByType: Record<NotificationType, LucideIcon> = {
  deployment_started: Rocket,
  deployment_success: CircleCheck,
  deployment_failed: CircleX,
  secret_sync_completed: KeyRound,
  server_offline: ServerOff,
  team_invite: Users,
  workflow_failed: Workflow,
  approval_required: ShieldQuestion,
};

export function notificationIcon(type: NotificationType): LucideIcon {
  return iconByType[type] ?? Bell;
}

// Compact relative time matching the app-wide "Xm ago" idiom
// (ProjectOverviewTab, PipelineCard use the same shape).
export function formatRelativeTime(iso: string): string {
  const seconds = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}
